/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { Text } from '@atlaskit/primitives/compiled';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';

const CommentAuthorActivity = () => {
	const { formatMessage } = useIntl();

	const { showAddedCommentDescription, isDeleted } = useCommentContext();

	if (isDeleted || !showAddedCommentDescription) {
		return null;
	}

	return (
		// eslint-disable-next-line jira/integration/test-id-by-folder-structure
		<Text testId="issue-comment-base.ui.comment.action">
			{expVal('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)
				? formatMessage(messages.addedCommentDescriptionLowercase, {
						span: (...text: React.ReactNode[]) => <Text weight="medium">{text}</Text>,
					})
				: formatMessage(messages.addedCommentDescription, {
						span: (...text: React.ReactNode[]) => <Text weight="medium">{text}</Text>,
					})}
		</Text>
	);
};

export default CommentAuthorActivity;
